    <!-- Sidebar navigation -->
  <div class="container-fluid">
    <app-navbar></app-navbar>
    <div class="row">
  
      <!-- <nav class="col-md-2 d-md-block bg-light sidebar">
        <div>
          <a routerLink="/home" class="navbar-brand"><img src="../../../assets/images/Solar Academy 2.png" width="100" height="100" alt="SolarTaxi Logo"/></a>
        </div>
        <div class="sidebar-sticky">
          <ul class="nav flex-column">
            <li class="nav-item">
              <a class="nav-link active" routerLink="/dashboard">
                <i class="fa fa-user-circle-o" aria-hidden="true"></i>User Profile
              </a>
            </li> -->
            <!-- Calling SignOut() Api from AuthService -->
            <!-- <li class="nav-item">
              <a class="nav-link" (click)="authService.SignOut()">
                <i class="fa fa-sign-out" aria-hidden="true"></i>Log out
              </a>
            </li> -->
          <!-- </ul>
        </div> -->
       <!-- <nav class="col-md-2 d-md-block sidebar">
        <div>
          <a routerLink="/home" class="navbar-brand"><img src="../../../assets/images/Solar Academy 2.png" width="100" height="100" alt="SolarTaxi Logo"/></a>
        </div>
      </nav> -->
  
      <!-- Main content -->
      <main role="main" class="col-md-9 ml-sm-auto col-lg-10 px-4">
        <div class="inner-adjust container-responsive">

          <!-- Stats cards -->
          <div class="row mb-4">
            <div class="col-6 col-md-3 mb-3" *ngIf="true">
              <div class="stat-card p-3">
                <div class="stat-value">{{ dashboardService?.applicationsCount || 0 }}</div>
                <div class="stat-label">Applications</div>
              </div>
            </div>
            <div class="col-6 col-md-3 mb-3">
              <div class="stat-card p-3">
                <div class="stat-value">{{ dashboardService?.coursesEnrolled || 0 }}</div>
                <div class="stat-label">Courses</div>
              </div>
            </div>
            <div class="col-6 col-md-3 mb-3">
              <div class="stat-card p-3">
                <div class="stat-value">{{ dashboardService?.progressPercent || 12 }}%</div>
                <div class="stat-label">Progress</div>
              </div>
            </div>
            <div class="col-6 col-md-3 mb-3">
              <div class="stat-card p-3">
                <div class="stat-value">{{ dashboardService?.upcomingEvents || 0 }}</div>
                <div class="stat-label">Events</div>
              </div>
            </div>
          </div>

          <!-- Profile + Actions -->
          <div class="row mb-4">
            <div class="col-lg-4 mb-3">
              <div class="card profile-card p-3">
                <div class="text-center">
                  <img class="profile-img mb-3" [src]="(user?.photoURL) ? user.photoURL : '../../../assets/images/SolarProfileLogo.png'" alt="{{user?.displayName || 'User'}}" />
                  <h4 class="mb-1">{{ user?.displayName || 'User' }}</h4>
                  <p class="text-muted mb-1">{{ user?.email }}</p>
                  <p class="text-muted">{{ user?.phoneNumber || 'No phone set' }}</p>
                </div>
                <div class="d-grid mt-3">
                  <a class="btn btn-primary" [routerLink]="['/profile']">Edit Profile</a>
                </div>
              </div>
            </div>

            <div class="col-lg-8 mb-3">
              <div class="card p-3">
                <h5 class="card-title">Recommended Course</h5>
                <div class="d-flex gap-3 align-items-center">
                  <img src="../../../assets/images/IMG_0478.jpg" alt="Electric Vehicle" width="110" height="110" class="rounded"/>
                  <div class="flex-fill">
                    <h6 class="mb-1">Introduction to Electric Vehicle</h6>
                    <div class="progress mb-2">
                      <div class="progress-bar bg-solarblue" role="progressbar" style="width:20%" aria-valuenow="20" aria-valuemin="0" aria-valuemax="100"></div>
                    </div>
                    <a class="btn btn-solarblue" [routerLink]="['/electric-cars/']">Continue Course</a>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Assessments grid -->
          <div class="row g-3">
            <div class="col-12">
              <h5 class="mb-3">Assessments</h5>
            </div>
            <div class="col-6 col-md-4 col-lg-3" *ngFor="let a of userAssessments">
              <div class="card assessment-card h-100 p-3">
                <div class="d-flex flex-column h-100">
                  <div class="mb-2">
                    <h6 class="mb-1">{{ a.name }}</h6>
                    <p class="text-muted small mb-0">Quick assessment to place you on the right track.</p>
                  </div>
                  <div class="mt-auto">
                    <a class="small" [href]="a.link" target="_blank">Take assessment</a>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </main>
  
    </div>
  </div>


